import { Component, OnInit, OnDestroy } from '@angular/core';
import { EventEmitterService } from '../event-emitter.service';
import { Router, ActivatedRoute} from '@angular/router';
// 1
import { TotemService } from '../totem.service';
import {
  ICON_BAR_RUTA,
  ICON_BAR_BUSCAR,
  ICON_BAR_ESTACIONAMIENTO,
  ICON_BAR_INFORMATION
} from '../assets-inline';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit, OnDestroy {

  estadoFooter = true;
  // 2
  public actual: string = '';

  // Iconos del footer inlineados como base64 para no fallar con
  // ERR_CONNECTION_REFUSED si el dev server estuvo reciclando.
  public iconRuta            = ICON_BAR_RUTA;
  public iconBuscar          = ICON_BAR_BUSCAR;
  public iconEstacionamiento = ICON_BAR_ESTACIONAMIENTO;
  public iconInformation     = ICON_BAR_INFORMATION;

  constructor(private eventEmitterService: EventEmitterService, private router: Router,
              private route: ActivatedRoute,public totemService: TotemService) {
    router.events.subscribe((val) => {
      this.comprobarPath();
    });
    // 3
    this.actual = this.totemService.actualLanguage;
   }

  ngOnInit() {
    console.log(this.eventEmitterService);
    // if (this.eventEmitterService.subsVar === undefined) {

    this.eventEmitterService.subsVar = this.eventEmitterService.invokeFooterComponentFunction.subscribe((name: string) => {
      console.log('llamado header footer');
      if (name === 'show') {
        this.mostrarFooter();
      } else if (name === 'hide') {
        this.ocultarFooter();
      }
      console.log('[HEADER]', name);
    });
    // }

  }

  comprobarPath() {
    const tipoRuta = this.router.url.split('/')[1];
    this.estadoFooter = tipoRuta === 'mapa-new' || tipoRuta === 'mapa' ? false : true;
  }
  ngOnDestroy() {
    this.eventEmitterService.subsVar.unsubscribe();
}

  ocultarFooter() {
    this.estadoFooter = false;
  }
  mostrarFooter() {
    this.estadoFooter = true;
  }
// 4
changeLanguage(language: any) {
  this.actual = language;
  this.totemService.changeLanguage(language);
}
getTranslation(key: string) {
  const word = this.totemService.getTranslation(key);
  if (word){
    return word[0].texto_descripcion;
  }
}
}
